import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form/immutable'
import { Map } from 'immutable'
import { withTranslation } from 'react-i18next'

import { required, dateRangeRequired } from 'helpers/validators'
import ErrorLabel from 'app/components/ErrorLabel'
import Input from 'app/components/Input'
import EmptyBlock from '../EmptyBlock'
import PlusMinusButtons from '../PlusMinusButtons'
import DateRangeField from '../DateRangeField'

import './styles.scss'
import Button from '../ButtonDefault/ButtonDefault'
const baseClass = 'date-ranges-field-array'

/**
 * Important!!! in order make this component working you should add `import 'react-dates/initialize'` one time per project
 * to your entire file of your project and use this component like a redux FieldArray component:
 *
 * import DateRangesFieldArray from '.../DateRangesFieldArray'
 *
 * ...
 * <FieldArray
 *   name='range' // or some other name
 *   component={DateRangesFieldArray}
 * />
 */
class DateRangesFieldArray extends Component {
  static defaultProps = {
    title: 'No Ranges Added',
    btnText: 'Add New Range',
    emptyBlockStretched: true,
    isShowSubmitButton: false,
  }

  static propTypes = {
    fields: PropTypes.shape({
      push: PropTypes.func,
      remove: PropTypes.func,
      map: PropTypes.func,
    }).isRequired,
    meta: PropTypes.shape({
      error: PropTypes.string,
    }),
    screenWidth: PropTypes.number,
    title: PropTypes.string,
    btnText: PropTypes.string,
    onRemoveConfirm: PropTypes.func,
    withName: PropTypes.bool,
    emptyBlockStretched: PropTypes.bool,
    isShowSubmitButton: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func,
  }

  handleAdd = index => () => {
    const { fields } = this.props
    const newIndex = index === undefined ? 0 : index + 1
    fields.insert(newIndex, Map({ startDate: null, endDate: null }))
  }

  handleRemove = index => () => {
    const { onRemoveConfirm } = this.props
    if (onRemoveConfirm) {
      onRemoveConfirm(index)
        .then(callback => {
          this.props.fields.remove(index)
          callback()
        })
        .catch(err => console.log('Try to confirm removing item from DateRangesFieldArray, but catch the error', err))
    } else {
      this.props.fields.remove(index)
    }
  }

  render() {
    const {
      t,
      fields,
      meta: { error, pristine },
      modalWidth,
      screenWidth,
      title,
      btnText,
      withName,
      emptyBlockStretched,
      isShowSubmitButton,
      handleSubmit,
    } = this.props
    if (!fields.length) {
      return (
        <EmptyBlock
          onAdd={this.handleAdd()}
          title={title}
          btnText={btnText}
          stretch={emptyBlockStretched}
          isShowSubmitButton={isShowSubmitButton}
          handleSubmit={handleSubmit}
          submitBtnText={t('Save')}
          isDisabledBtnText={pristine}
        />
      )
    }
    return (
      <Fragment>
        <ul className={baseClass}>
          {fields.map((field, index) => (
            <li key={index}>
              <PlusMinusButtons
                onAdd={this.handleAdd(index)}
                onRemove={this.handleRemove(index)}
                className={`${baseClass}__buttons`}
              />
              {withName && (
                <Field
                  name={`${field}.name`}
                  component={Input}
                  className={`${baseClass}__input-name--wrapper`}
                  inputClass={`${baseClass}__input-name`}
                  placeholder={t('Holiday Name')}
                  validate={[required()]}
                />
              )}
              <Field
                name={field}
                type="text"
                component={DateRangeField}
                screenWidth={modalWidth || screenWidth}
                validate={[dateRangeRequired(t('invalid range'))]}
              />
            </li>
          ))}
          {!!error && <ErrorLabel error={error} />}
        </ul>
        {isShowSubmitButton && (
          <Button primary sm onClick={handleSubmit} disabled={pristine}>
            {t('Save')}
          </Button>
        )}
      </Fragment>
    )
  }
}

export default withTranslation()(DateRangesFieldArray)
